module.exports = __webpack_public_path__ + "img/9791158884840.ecc7847d.jpg";